// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statis {\n  display: inline-block;\n  margin: 0 20px 20px 0;\n}\n", ""]);
// Exports
module.exports = exports;
